import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ContactFooter } from "@/components/ContactFooter";

export default function PaymentCancel() {
  const { user } = useAuth();
  const isLogged = Boolean(user || localStorage.getItem("token"));

  return (
    <div className="min-h-screen bg-white">
      <header className="max-w-3xl mx-auto px-4 pt-6">
        <div className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full bg-[color:var(--volt)] border border-black/10" aria-hidden="true" />
          <span className="font-extrabold tracking-tight uppercase text-sm">Propedeutico</span>
        </div>
      </header>
      <div className="max-w-md mx-auto px-4 pt-14 pb-16 text-center fade-up" data-testid="payment-cancel">
        <span className="inline-flex w-14 h-14 rounded-full bg-[color:var(--bg-subtle)] border border-[color:var(--hairline)] items-center justify-center" aria-hidden="true">
          <XCircle className="w-6 h-6 text-[color:var(--text-2)]" />
        </span>
        <h1 className="mt-5 text-2xl font-extrabold tracking-tight">Pagamento annullato.</h1>
        <p className="mt-2 text-sm text-[color:var(--text-2)] leading-6">
          Nessun importo è stato addebitato. Puoi riprovare quando vuoi: l'accesso completo ti aspetta.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link
            to={isLogged ? "/sblocca" : "/login"}
            data-testid="payment-cancel-retry-button"
            className="press rounded-full bg-[color:var(--volt)] text-[color:var(--ink)] font-extrabold px-6 py-3 min-h-[44px] hover:brightness-95 transition-all duration-200"
          >
            {isLogged ? "Riprova — 39 €" : "Accedi e riprova"}
          </Link>
          <Link
            to={isLogged ? "/" : "/login"}
            data-testid="payment-cancel-home-button"
            className="press rounded-full border border-[color:var(--hairline)] font-bold px-6 py-3 min-h-[44px] hover:bg-[color:var(--bg-subtle)] transition-colors duration-200"
          >
            Home
          </Link>
        </div>
        <div className="flex justify-center">
          <ContactFooter className="pb-10" />
        </div>
      </div>
    </div>
  );
}
